import React from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';

import Link from '../../../../library/link/link';

import './vehicle-landing-page-hero-banner.scss';

function VehicleLandingPageHeroBanner(props) {
  const { bannerComponent } = props;

  const mainHero = bannerComponent.slides?.[0] || null;

  function getHeroImgAttrs(hero) {
    const imgUrl = hero?.image?.url || '';

    return {
      alt: hero?.image?.altText,
      sizes: `
        (max-width: 375px) 375px,
        (max-width: 768px) 768px,
        (max-width: 1024px) 1024px,
        (max-width: 1200px) 1200px,
        (max-width: 1920px) 1920px,
        1200px
      `,
      src: `${imgUrl}?$vlpMobile$`,
      srcset: `
      ${imgUrl}?$vlpMobile$ 375w,
      ${imgUrl}?$vlpSmall$ 768w,
      ${imgUrl}?$vlpMed$ 1024w,
      ${imgUrl}?$vlpLarge$ 1200w,
      ${imgUrl}?$vlpFull$ 1920w
      `
    };
  }

  const mainHeroImgAttrs = getHeroImgAttrs(mainHero);

  return (
    <div styleName="container">
      {window.isPreRendering && Object.keys(mainHero).length > 0 && (
        <Helmet>
          <link
            as="image"
            href={mainHeroImgAttrs.src}
            imageSizes={mainHeroImgAttrs.sizes}
            imageSrcSet={mainHeroImgAttrs.srcset}
            rel="preload"
          />
        </Helmet>
      )}
      {mainHero?.link?.href ? (
        <Link styleName="hero-image" to={mainHero.link.href}>
          <img
            alt={mainHeroImgAttrs.alt}
            sizes={mainHeroImgAttrs.sizes}
            src={mainHeroImgAttrs.src}
            srcSet={mainHeroImgAttrs.srcset}
          />
        </Link>
      ) : (
        <img
          alt={mainHeroImgAttrs.alt}
          sizes={mainHeroImgAttrs.sizes}
          src={mainHeroImgAttrs.src}
          srcSet={mainHeroImgAttrs.srcset}
          styleName="hero-image"
        />
      )}
    </div>
  );
}

VehicleLandingPageHeroBanner.propTypes = {
  bannerComponent: PropTypes.object
};

export default VehicleLandingPageHeroBanner;
